import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "sl", "hr", "sk", "cs", "de-AT", "it", "pl"],
  defaultLocale: "sl",
  localePrefix: "always",
});
